import ServiceSummary from './ServiceSummary.css';
import ServiceSummaryOption from './components/ServiceSummaryOption/ServiceSummaryOption.css';
import ServiceSummaryDivider from './components/ServiceSummaryDivider/ServiceSummaryDivider.css';
import ServiceSummaryNotification from './components/ServiceSummaryNotification/ServiceSummaryNotification.css';

export default {
	ServiceSummary,
	ServiceSummaryOption,
	ServiceSummaryDivider,
	ServiceSummaryNotification
};
